// imports

// class
export default class BoundListenerMgr {

    // constructor
    constructor(args = {}){
        // set properties
        this._map = new Map();
        this._scope = args.scope;
    }

    // methods
    add(key, method, scopeOverride = null) {
        // define scope
        const scope = scopeOverride || this._scope;

        // bind listener
        const boundMethod = method.bind(scope)

        // add to map
        this._map.set(key, {
            originalMethod: method,
            boundMethod: boundMethod,
            scope: scope
        });

        // return this for chaining
        return boundMethod;
    }

    addOnce(key, method, scopeOverride) {
        const original = this._map.get(key);
        return original ? original : this.add(key, method, scopeOverride);
    }

    get (key) {
        return this._map.get(key)?.boundMethod;
    }
    
    getDefinition(key) {
        return this._map.get(key);
    }

    remove (key) {
        if (this._map.has(key)) {
            const listener = this._map.get(key);
            this._map.delete(key);
            return listener.boundMethod;
        }

        return null;
    }

    destroy() {
        // clear map
        this._map.clear();
    }

    // getters & setters
    map () {
        return this._map;
    }
    
}

// utils


// listeners